import { render, staticRenderFns } from "./normalGoods.vue?vue&type=template&id=eea555ee&scoped=true"
import script from "./normalGoods.vue?vue&type=script&lang=js"
export * from "./normalGoods.vue?vue&type=script&lang=js"
import style0 from "./normalGoods.vue?vue&type=style&index=0&id=eea555ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea555ee",
  null
  
)

export default component.exports